import { useState } from "react";

export function usePackageModal() {
    const [selectedPkg, setSelectedPkg] = useState<any>(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageText, setMessageText] = useState("");

    const openDetail = (pkg: any) => {
        setSelectedPkg(pkg);
        setShowDetailModal(true);
    };

    const closeDetail = () => setShowDetailModal(false);

    const openMessage = () => {
        setShowDetailModal(false);
        setShowMessageModal(true);
    };

    const closeMessage = () => {
        setShowMessageModal(false);
        setShowDetailModal(true);
    };

    return {
        selectedPkg,
        showDetailModal,
        showMessageModal,
        messageText,
        setMessageText,

        openDetail,
        closeDetail,
        openMessage,
        closeMessage,
    };
}
